module.exports = __webpack_public_path__ + "pnskfsquadron/img/m-book-hero11.png?a6e75798";